/*
 * Module for Topic Listing Utility
 */

define([
  "marionette",
  "backbone",
  "messaging/messenger",
  "configuration/properties",
  "./topicListingView",
  "./topicListingModel",
], function (Marionette, Backbone, Messenger, Properties, TopicListingView, TopicListingModel) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "TopicListing";
      this.region = options.region;
      this._setUpVents();
    },

    show: function () {
      const touchpoints = Messenger.reqres.request("kb:touchpoints") || [];
      const locales = Messenger.reqres.request("kb:languages") || [];

      const model = new TopicListingModel.topicListingExport();
      model.touchpoints = touchpoints;
      model.locales = locales;

      this.view = new TopicListingView.topicListingView({
        model: model,
      });

      this.listenTo(this.view, "export:listing", this._onExportListing);

      this.showRegion(this.view);
    },

    _onExportListing: function (params) {
      try {
        const fileFormat = params.format;
        const fileName = `Topic Listing.${fileFormat}`;

        const model = this.view.model;
        model.set({
          abbreviated: !!params.abbreviated,
          includeBranchTopics: !!params.includeBranchTopics,
          showBlankResponses: !!params.showBlankResponses,
          localeIds: params.localeIds,
          touchPointIds: params.touchPointIds,
          fileName,
        });

        this._downloadTopicListing(model, fileFormat);
      } catch (e) {
        console.error("Error triggering topic listing export", e);
        Messenger.okDialog("Failed to start topic listing download.");
      }
    },

    _downloadTopicListing: function (model, fileFormat) {
      const url = model.url() + "?format=" + fileFormat;
      const payload = model.toJSON();

      const authHeader = Messenger.reqres.request("authorization:header");
      const headers = { "Content-Type": "application/json" };
      if (authHeader) headers.Authorization = authHeader;

      const fetchOptions = {
        method: "POST",
        headers,
        body: JSON.stringify(payload),
        mode: Properties.allowCors ? "cors" : "same-origin",
        credentials: Properties.allowCors ? "include" : "same-origin",
      };

      fetch(url, fetchOptions)
        .then((res) => {
          if (!res.ok) throw res;
          return res.blob();
        })
        .then((blob) => saveAs(blob, payload.fileName))
        .catch((err) => Messenger.showErrorFromResponse(err));
    },

    _setUpVents: function () {
      Messenger.vent.on("show:authoring:admin:topicListing", () => {
        const kbId = Messenger.reqres.request("active:kb");
        Backbone.history.navigate(kbId + "/authoringAdmin/topicListing");
        this.show();
      });
      Messenger.vent.on("show:kb:admin:topicListing", () => {
        const kbId = Messenger.reqres.request("active:kb");
        Backbone.history.navigate(kbId + "/authoringAdmin/topicListing");
        this.show();
      });
    },
  });
});
